import React, {createRef, Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import moment from "moment";

import {createUserWarning} from "../../../creators/user.warning";
import {fetchTagsWarning} from "../../../creators/tagsWarning";

import {Button, ButtonGroup} from "../Button";
import {DateInputField, NumberInputField} from "../FormField";
import ListTypeMessages from "./ListTypeMessages";
import WarningEditor from "./WarningEditor/WarningEditor";
import convertToNext from "../../../libs/lexical/convertissors/simple";

class WarnUser extends React.Component {
    constructor(props) {
        super(props);
        let startDate = new Date();
        this.firstEditorRef = createRef();
        let endDate = moment(startDate).add("1", 'days');
        this.initialWarning = {
            // contentRaw: {},
            // moderatorNoteRaw: {},
            warningReason: '',
            // tag: "5c86efe9180bdd0a546125a9",
            restriction: {
                type: 0,
                isPermanent: false,
                startedAt: startDate,
                endedAt: endDate
            }
        };
        this.state = {
            memberNoteState : {},
            moderatorNoteState : {},
            edit : {},
            warning: this.initialWarning,
            restrictionDuration: 1,
            hoursToAdd: 1,
            warningPoint: 0,
            submitWarning: []
        };
        this.handleContent = this.handleContent.bind(this);
        this.handleRestriction = this.handleRestriction.bind(this);
        this.handleRestrictionDuration = this.handleRestrictionDuration.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.props.fetchTagsWarning();
    }

    handleContent(name, value) {
        this.setState({warning: {...this.state.warning, [name]: value}});
    }

    handleRestriction(name, value){
        this.setState({warning: {...this.state.warning, restriction: {...this.state.warning.restriction, [name]: value}}});
    }

    handleHourRestriction(value){
        let truncValue = Math.trunc(value);
        if(truncValue >= 23){
            truncValue = 23
        }
        if(truncValue < 1){
            truncValue = null
        }
        let startDate = new Date();
        let endDate = moment(startDate).add(truncValue, 'hours');
        this.setState({hoursToAdd : truncValue, warning: {...this.state.warning, restriction: {...this.state.warning.restriction, endedAt: endDate}}});
    }

    handleRestrictionDuration(name, value){
        if(name === "isPermanant"){
            this.setState({restrictionDuration: 0, warning: {...this.state.warning, restriction: {...this.state.warning.restriction, isPermanent : value}}});
        } else {
            this.setState({restrictionDuration: value, warning: {...this.state.warning, restriction: {...this.state.warning.restriction, isPermanent: false}}});
        }
    }

    handleSubmit() {
        if(this.state.warning.tag){
            let {text : note} = convertToNext(this.state.memberNoteState);
            let {text : moderatorNote} = convertToNext(this.state.moderatorNoteState);
            this.props.createUserWarning(this.props.userId, {
                ...this.state.warning,
                note,
                moderatorNote
            });
            this.props.handleClose();
        }

    }

    _onSelectText(text){
        if (this.firstEditorRef.current) this.firstEditorRef.current.insert(text);
    }

    render() {
        // console.log(this.firstEditorRef);
        return (
            <div id="warnUser" className="modal-container">
                <div className="modal-topline">Avertir <b>{this.props.username}</b></div>
                <div className={"modal-body column"}>
                    <div className="column my-8">
                        <div className="text label bold pb-4">Message Type</div>
                        <ListTypeMessages onSelect={this._onSelectText.bind(this)}  />
                    </div>
                    <div className="column my-8">
                        <div className="text label bold pb-4">Note au membre</div>
                        <WarningEditor onChange={(editorState)=>this.setState({memberNoteState:editorState})} ref={this.firstEditorRef}/>
                    </div>
                    <div className="column my-8">
                        <div className="text label bold pb-4">Note pour les modérateurs</div>
                        <WarningEditor onChange={(editorState)=>this.setState({moderatorNoteState:editorState})}/>
                    </div>
                    <div className="row">
                        <div className="column my-8 full">
                            <div className="text label bold pb-4">Raison</div>
                            <select name="warningReason" value={this.state.warning.tag}
                                    onChange={(event) => this.handleContent("tag", event.target.value)}>
                                <option value="">--Sélectionner une raison--</option>
                                {this.props.tagsWarning.map(item => <option key={item._id} value={item._id}>{item.title}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column my-8 full">
                            <div className="text label bold pb-4">Punition</div>
                            <select name="restriction"
                                    value={this.state.warning.restriction.type}
                                    onChange={(event) => this.handleRestriction("type", event.target.value)}
                            >
                                <option value="0">Message verbal uniquement</option>
                                <option value="1">Supprimer la capacité à créer du contenu</option>
                                <option value="3">Invisibilité des médias et interdiction de nouvelle publication</option>
                                {/*<option value="2">Suspendre</option>*/}
                            </select>
                        </div>
                    </div>
                    {(this.state.warning.restriction.type === 1 || this.state.warning.restriction.type === "1") && (
                        <div className={"column punishment-section"}>
                            <div className="text label bold pb-4">Durée de la sanction</div>
                            <ButtonGroup>
                                <Button onClick={()=>this.handleRestrictionDuration("isPermanant", true)}
                                        active={this.state.restrictionDuration === 0}
                                        content={"Permanente"} />
                                <Button onClick={()=>this.handleRestrictionDuration("restrictionDuration", 1)}
                                        active={this.state.restrictionDuration === 1}
                                        content={"Jours"} />
                                <Button onClick={()=>this.handleRestrictionDuration("restrictionDuration", 2)}
                                        active={this.state.restrictionDuration === 2}
                                        content={"Heures"} />
                            </ButtonGroup>
                            {!this.state.warning.restriction.isPermanent && (
                                <Fragment>
                                    {(this.state.restrictionDuration === 1 || this.state.restrictionDuration === "1") && (
                                        <div className={"restriction-duration"}>
                                            Du&nbsp;
                                            <DateInputField value={this.state.warning.restriction.startedAt}
                                                            format={"DD/MM/YYYY"}
                                                            nameOfValueToUpdate={"startedAt"}
                                                            convertToFormat={"YYYY-MM-DD"}
                                                            showTime={false}
                                                            handleValue={this.handleRestriction}/>&nbsp;
                                            au&nbsp;
                                            <DateInputField value={this.state.warning.restriction.endedAt}
                                                            format={"DD/MM/YYYY"}
                                                            nameOfValueToUpdate={"endedAt"}
                                                            convertToFormat={"YYYY-MM-DD"}
                                                            showTime={false}
                                                            handleValue={this.handleRestriction}/>&nbsp;
                                        </div>
                                    )}
                                    {(this.state.restrictionDuration === 2 || this.state.restrictionDuration === "2") && (
                                        <div className={"restriction-duration"}>
                                            <NumberInputField onChange={(event)=>this.handleHourRestriction(event.target.value)}
                                                              min={1}
                                                              max={23}
                                                              type="number"
                                                              step={"1"}
                                                              value={this.state.hoursToAdd} />&nbsp;
                                            heures
                                        </div>
                                    )}
                                </Fragment>
                            )}
                        </div>
                    )}
                </div>
                <div className="modal-baseline">
                    <Button size={"small"}
                            btnStyle={"grey"}
                            onClick={() => this.props.handleClose()}
                            content={"Annuler"}/>
                    <Button size={"small"}
                            btnStyle={"primary-reverse"}
                            disabled={!this.state.warning.tag}
                            onClick={() => this.handleSubmit()}
                            content={"Envoyer"}/>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        tagsWarning: state.tagsWarning.data,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    createUserWarning,
    fetchTagsWarning
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(WarnUser);
